import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
  faUser,
  faUsers,
  faLock,
  faSignOutAlt,
  faCog,
  faRobot,
  faTachometerAlt,
  faHandPointRight,
  faHandPointLeft,
  faChartBar,
  faCaretDown,
  faUserClock,
  faAngleDoubleRight,
  faTable,
  faClock,
  faEye,
  faUpload,
  faComment,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faUser,
  faUsers,
  faLock,
  faSignOutAlt,
  faCog,
  faGithub,
  faRobot,
  faTachometerAlt,
  faHandPointRight,
  faHandPointLeft,
  faChartBar,
  faCaretDown,
  faUserClock,
  faAngleDoubleRight,
  faTable,
  faClock,
  faEye,
  faUpload,
  faComment,
  faTimes
);

Vue.component('fa', FontAwesomeIcon);
